import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { logout } from 'store/actions';
import { Loader } from './Loader';
import { ADMIN_LOGOUT_URL, AREP_LOGOUT_URL, POB_LOGOUT_URL, GOV_HR_URL } from 'constants';

export const End = () => {

  const dispatch = useDispatch();
  const cookieNames = ["token", "securityLevel","nias-token"];
  const subjectId = localStorage.getItem('subjectId');

  useEffect(()=>{
    const sent = window.navigator.sendBeacon(`${ADMIN_LOGOUT_URL}?subjectId=${subjectId}`);
    console.log(sent);

    setTimeout(()=>{
      cleaner();
    },5000)
  },[]);

  const cleaner = () => {
    for (const cookie of cookieNames) {
      document.cookie = cookie + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }

    dispatch(logout(() => window.location.href = GOV_HR_URL));
  }

  return (
    <>
      <iframe id="arep" src={AREP_LOGOUT_URL} title="AREP" hidden></iframe>
      <iframe id="pob" src={POB_LOGOUT_URL} title="POB" hidden></iframe>  
      <Loader/>
    </>
  )
}

